import errorHandler from './errorHandler';
import middleware from './middleware';
import composeEnhancers from '../../util/composeEnhancers';
var enhancer = composeEnhancers(middleware, errorHandler);
export default enhancer;